// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
.main-layout {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-layout .main-header {
  flex: 0 0 auto;
}
.main-layout .main-content {
  flex: 1 1 auto;
  align-items: stretch;
  overflow-y: auto;
}

:host ::ng-deep .page-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
}
:host ::ng-deep .page-layout .page-header {
  flex: 0 0 auto;
  padding-top: 20px;
  padding-bottom: 20px;
  min-height: 76px;
}
:host ::ng-deep .page-layout .page-header .btn {
  padding: 5px 15px;
}
:host ::ng-deep .page-layout .page-content {
  flex: 1 1 auto;
  overflow-y: auto;
}
:host ::ng-deep .card.page-layout {
  border-radius: 0;
  border-left-width: 0;
  border-right-width: 0;
}
:host ::ng-deep .card.page-layout .card-header.page-header {
  border-radius: 0;
}
:host ::ng-deep .navbar-light {
  box-shadow: 0 2px 15px 0 rgba(0, 73, 109, 0.1);
}
:host ::ng-deep .navbar-brand img {
  height: 25px;
}
:host ::ng-deep a {
  font-size: 16px;
  font-weight: bold;
}
:host ::ng-deep a i-feather {
  margin-right: 14px;
  height: 18px !important;
  width: 18px !important;
}
:host ::ng-deep a.btn {
  font-size: 1rem;
}
:host ::ng-deep i-feather.plusicon::ng-deep {
  width: 18px;
  height: 18px;
}
:host ::ng-deep i-feather.plusicon::ng-deep svg {
  position: relative;
  top: -2px;
  width: 18px;
  height: 18px;
}
:host ::ng-deep i-feather.fms-icon::ng-deep {
  height: 20px;
}
:host ::ng-deep i-feather.fms-icon::ng-deep svg {
  position: relative;
  height: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-delete-icon::ng-deep {
  height: 20px;
  color: #f64540;
  cursor: pointer;
}
:host ::ng-deep i-feather.fms-delete-icon::ng-deep svg {
  position: relative;
  height: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-add-icon::ng-deep {
  height: 20px !important;
  width: 20px !important;
  color: #1ba953;
}
:host ::ng-deep i-feather.fms-add-icon::ng-deep svg {
  position: relative;
  height: 20px;
  width: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-cancel-icon::ng-deep {
  height: 20px !important;
  width: 20px !important;
  color: #f64540;
}
:host ::ng-deep i-feather.fms-cancel-icon::ng-deep svg {
  position: relative;
  height: 20px;
  width: 20px;
  top: -2px;
}
:host ::ng-deep i-feather.fms-input-icon::ng-deep {
  position: absolute;
  top: -1px;
  right: 21px;
  z-index: 2;
  display: block;
  width: 25px;
  height: 25px;
  line-height: 34px;
  text-align: center;
  pointer-events: none;
}
:host ::ng-deep .circle-icon {
  font-size: 25px;
}
:host ::ng-deep .circle-icon i-feather {
  height: 24px !important;
  width: 24px !important;
}
:host ::ng-deep .file-icon {
  height: 80px;
  width: 100%;
  fill: #1161be;
}
:host ::ng-deep .dropdown-menu {
  margin-top: 10px;
}
:host ::ng-deep .dropdown-menu .nav-link {
  white-space: nowrap;
}
:host ::ng-deep .fms-lb-background {
  background: #e1eefe;
}
:host ::ng-deep ngx-dropzone.fms-dropzone {
  background: #e1eefe;
  height: 80px;
  border: dashed 1px #1161be;
}
:host ::ng-deep ngx-dropzone.fms-dropzone.has-files {
  height: 180px;
}
:host ::ng-deep .fms-footer {
  position: absolute;
  bottom: 20px;
  width: 100%;
}
:host ::ng-deep .pull-right {
  float: right;
}
:host ::ng-deep .pull-left {
  float: left;
}
:host ::ng-deep .fms-grey-text {
  font-family: "Noto Sans";
  font-size: 15px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #252525;
}
:host ::ng-deep button.fms-button {
  height: 40px;
  min-width: 94px;
  border-radius: 4px !important;
  border: solid 2px #1161be !important;
  font-family: "Noto Sans";
  font-size: 16px !important;
  font-weight: bold !important;
}
:host ::ng-deep label.required:after {
  color: #f64540;
  content: " *";
}
:host ::ng-deep label {
  font-family: "Noto Sans";
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}
:host ::ng-deep .custom-control-label {
  vertical-align: top;
}
:host ::ng-deep input.ng-touched.ng-invalid:not(.skip-validation-style), :host ::ng-deep select.ng-touched.ng-invalid:not(.skip-validation-style), :host ::ng-deep textarea.ng-touched.ng-invalid:not(.skip-validation-style) {
  border-color: #f64540;
}
:host ::ng-deep ng-multiselect-dropdown.ng-touched.ng-invalid span.dropdown-btn:not(.skip-validation-style) {
  border-color: #f64540;
}
:host ::ng-deep select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #8291ae 50%), linear-gradient(135deg, #8291ae 50%, transparent 50%), linear-gradient(to right, #fff, #fff);
  background-position: calc(100% - 15px) 1em, calc(100% - 10px) 1em, 100% 0;
  background-size: 5px 5px, 5px 5px, 2.5em 2.5em;
  background-repeat: no-repeat;
}
:host ::ng-deep span.dropdown-down {
  border-top: 5px solid #8291ae !important;
  border-left: 5px solid transparent !important;
  border-right: 5px solid transparent !important;
}
:host ::ng-deep span.dropdown-up {
  border-bottom: 5px solid #8291ae !important;
  border-left: 5px solid transparent !important;
  border-right: 5px solid transparent !important;
}
:host ::ng-deep ng-multiselect-dropdown::ng-deep .dropdown-list {
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/app/layout/main-layout/main-layout.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC9LA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAYF;AAVE;EACE,cAAA;AAYJ;AATE;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;AAWJ;;AANE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AASJ;AAPI;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AASN;AAPM;EACE,iBAAA;AASR;AALI;EACE,cAAA;EACA,gBAAA;AAON;AAHE;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;AAKJ;AAHI;EACE,gBAAA;AAKN;AADE;EACE,8CAAA;AAGJ;AACI;EACE,YAAA;AACN;AAGE;EACE,eAAA;EACA,iBAAA;AADJ;AAGI;EACE,kBAAA;EAEA,uBAAA;EACA,sBAAA;AAFN;AAME;EACE,eAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;AALJ;AAOI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AALN;AASE;EACE,YAAA;AAPJ;AASI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;AAPN;AAWE;EACE,YAAA;EACA,cDrEM;ECsEN,eAAA;AATJ;AAWI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;AATN;AAaE;EACE,uBAAA;EACA,sBAAA;EACA,cD9FQ;ACmFZ;AAaI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAXN;AAeE;EACE,uBAAA;EACA,sBAAA;EACA,cD/FM;ACkFV;AAeI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAbN;AAiBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAfJ;AAkBE;EACE,eAAA;AAhBJ;AAkBI;EACE,uBAAA;EACA,sBAAA;AAhBN;AAoBE;EACE,YAAA;EACA,WAAA;EACA,aDzJO;ACuIX;AAqBE;EAEE,gBAAA;AApBJ;AAsBI;EACE,mBAAA;AApBN;AAwBE;EACE,mBDpKa;AC8IjB;AA2BI;EACE,mBD1KW;EC2KX,YAAA;EACA,0BAAA;AAzBN;AA2BI;EACE,aAAA;AAzBN;AA6BE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AA3BJ;AA8BE;EACE,YAAA;AA5BJ;AA+BE;EACE,WAAA;AA7BJ;AAgCE;EACE,wBD3Jc;EC4Jd,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cDxMY;AC0KhB;AAiCE;EACE,YAAA;EACA,eAAA;EACA,6BAAA;EACA,oCAAA;EACA,wBD1Kc;EC2Kd,0BAAA;EACA,4BAAA;AA/BJ;AAkCE;EACE,cDlMM;ECmMN,aAAA;AAhCJ;AAmCE;EACE,wBDrLc;ECsLd,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;AAjCJ;AAoCE;EACE,mBAAA;AAlCJ;AAqCE;EACE,qBDrNM;ACkLV;AAsCE;EACE,qBDzNM;ACqLV;AAuCE;EAEE,wBAAA;EACA,qBAAA;EAEA,oKAAA;EAGA,yEAAA;EAGA,8CAAA;EAGA,4BAAA;AA7CJ;AAgDE;EACE,wCAAA;EACA,6CAAA;EACA,8CAAA;AA9CJ;AAiDE;EACE,2CAAA;EACA,6CAAA;EACA,8CAAA;AA/CJ;AAmDI;EACE,aAAA;AAjDN","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"../../../styles/variables\";\n\n.main-layout {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n\n  .main-header {\n    flex: 0 0 auto;\n  }\n\n  .main-content {\n    flex: 1 1 auto;\n    align-items: stretch;\n    overflow-y: auto;\n  }\n}\n\n:host ::ng-deep {\n  .page-layout {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n\n    .page-header {\n      flex: 0 0 auto;\n      padding-top: 20px;\n      padding-bottom: 20px;\n      min-height: 76px;\n\n      .btn {\n        padding: 5px 15px;\n      }\n    }\n\n    .page-content {\n      flex: 1 1 auto;\n      overflow-y: auto;\n    }\n  }\n\n  .card.page-layout {\n    border-radius: 0;\n    border-left-width: 0;\n    border-right-width: 0;\n\n    .card-header.page-header {\n      border-radius: 0;\n    }\n  }\n\n  .navbar-light {\n    box-shadow: 0 2px 15px 0 rgba(0, 73, 109, 0.1);\n  }\n\n  .navbar-brand {\n    img {\n      height: 25px;\n    }\n  }\n\n  a {\n    font-size: 16px;\n    font-weight: bold;\n\n    i-feather {\n      margin-right: 14px;\n\n      height: 18px !important;\n      width: 18px !important;\n    }\n  }\n\n  a.btn {\n    font-size: 1rem;\n  }\n\n  i-feather.plusicon::ng-deep {\n    width: 18px;\n    height: 18px;\n\n    svg {\n      position: relative;\n      top: -2px;\n      width: 18px;\n      height: 18px;\n    }\n  }\n\n  i-feather.fms-icon::ng-deep {\n    height: 20px;\n\n    svg {\n      position: relative;\n      height: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-delete-icon::ng-deep {\n    height: 20px;\n    color: $fms-red;\n    cursor: pointer;\n\n    svg {\n      position: relative;\n      height: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-add-icon::ng-deep {\n    height: 20px !important;\n    width: 20px !important;\n    color: $fms-green;\n\n    svg {\n      position: relative;\n      height: 20px;\n      width: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-cancel-icon::ng-deep {\n    height: 20px !important;\n    width: 20px !important;\n    color: $fms-red;\n\n    svg {\n      position: relative;\n      height: 20px;\n      width: 20px;\n      top: -2px;\n    }\n  }\n\n  i-feather.fms-input-icon::ng-deep {\n    position: absolute;\n    top: -1px;\n    right: 21px;\n    z-index: 2;\n    display: block;\n    width: 25px;\n    height: 25px;\n    line-height: 34px;\n    text-align: center;\n    pointer-events: none;\n  }\n\n  .circle-icon {\n    font-size: 25px;\n\n    i-feather {\n      height: 24px !important;\n      width: 24px !important;\n    }\n  }\n\n  .file-icon {\n    height: 80px;\n    width: 100%;\n    fill: $fms-blue;\n  }\n\n  .dropdown-menu {\n\n    margin-top: 10px;\n\n    .nav-link {\n      white-space: nowrap;\n    }\n  }\n\n  .fms-lb-background {\n    background: $fms-blue-light;\n  }\n\n  ngx-dropzone {\n\n    &.fms-dropzone {\n      background: $fms-blue-light;\n      height: 80px;\n      border: dashed 1px $fms-blue;\n    }\n    &.fms-dropzone.has-files {\n      height: 180px;\n    }\n  }\n\n  .fms-footer {\n    position: absolute;\n    bottom: 20px;\n    width: 100%;\n  }\n\n  .pull-right {\n    float: right;\n  }\n\n  .pull-left {\n    float: left;\n  }\n\n  .fms-grey-text {\n    font-family: $fms-font-family;\n    font-size: 15px;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n    color: $fms-gray-dark;\n  }\n\n  button.fms-button {\n    height: 40px;\n    min-width: 94px;\n    border-radius: 4px !important;\n    border: solid 2px $fms-blue !important;\n    font-family: $fms-font-family;\n    font-size: 16px !important;\n    font-weight: bold !important;\n  }\n\n  label.required:after {\n    color: $fms-red;\n    content: ' *';\n  }\n\n  label {\n    font-family: $fms-font-family;\n    font-size: 16px;\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    line-height: normal;\n    letter-spacing: normal;\n  }\n\n  .custom-control-label {\n    vertical-align: top;\n  }\n\n  input.ng-touched.ng-invalid:not(.skip-validation-style), select.ng-touched.ng-invalid:not(.skip-validation-style), textarea.ng-touched.ng-invalid:not(.skip-validation-style) {\n    border-color: $fms-red;\n  }\n\n  ng-multiselect-dropdown.ng-touched.ng-invalid span.dropdown-btn:not(.skip-validation-style) {\n    border-color: $fms-red;\n  }\n\n  select {\n\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    background-image: linear-gradient(45deg, transparent 50%, $fms-gray 50%),\n    linear-gradient(135deg, $fms-gray 50%, transparent 50%),\n    linear-gradient(to right, $fms-white, $fms-white);\n    background-position: calc(100% - 15px) calc(1em),\n    calc(100% - 10px) calc(1em),\n    100% 0;\n    background-size: 5px 5px,\n    5px 5px,\n    2.5em 2.5em;\n    background-repeat: no-repeat;\n  }\n\n  span.dropdown-down {\n    border-top: 5px solid $fms-gray !important;\n    border-left: 5px solid transparent !important;\n    border-right: 5px solid transparent !important;\n  }\n\n  span.dropdown-up {\n    border-bottom: 5px solid $fms-gray !important;\n    border-left: 5px solid transparent !important;\n    border-right: 5px solid transparent !important;\n  }\n\n  ng-multiselect-dropdown::ng-deep {\n    .dropdown-list {\n      margin-top: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
